import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonCellBatchRunModel extends ModeModelBase {
  override _name = 'pythonCellBatchRun';
  override parentModel = 'pythonNotebook';
  override hasMany = [{ name: 'pythonCells' }];
}
@Injectable({ providedIn: 'root' })
export class PythonCellBatchRunModelAccessor extends ModelAccessorBase<PythonCellBatchRunModel> {
  override name = 'pythonCellBatchRun';
  override parentModel = 'pythonNotebook';
  createModel(resource, opts?) {
    const model = new PythonCellBatchRunModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonCellBatchRun');
  }
}
